export const designSystemPages = [
  {
    path: 'design-system',
    name: 'design_system_route',
    component: () => import('@/views/designSystem/TheDesignSystemPage.vue')
  }
]
